const paymentAddress = {
  addTitle: 'Add new billing address',
  addSubtitle: 'You can add your billing address here.',
  editTitle: 'Edit Address',
  editSubtitle: 'You can edit your billing address here.',
  save: 'Save',
  update: 'Update',
  back: 'back',
  newSuccess: 'Your new billing address has been successfully added',
  editSuccess: 'Your billing address has been changed successfully',
  fillNecessary: '* Please fill out the mandatory fields',
}

export default paymentAddress
